// removed by extract-text-webpack-plugin
module.exports = {"overlay":"c-Overlay__overlay"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/Overlay/Overlay.scss
// module id = 559
// module chunks = 0